import { FunctionComponent, PropsWithChildren } from "react";

interface Props {
  title?: string;
  actions?: React.ReactNode;
}

export const CardWithTitle: FunctionComponent<PropsWithChildren<Props>> = ({
  title,
  children,
  actions,
}) => {
  return (
    <div className="mt-4 overflow-hidden rounded-xl border border-gray-100 bg-white shadow-sm">
      {(title || actions) && (
        <div className="flex items-center justify-between border-b border-gray-100 px-6 py-4">
          {title && (
            <h3 className="text-base font-semibold text-gray-900 dark:text-white">
              {title}
            </h3>
          )}
          {actions && <div>{actions}</div>}
        </div>
      )}
      <div className="p-6">{children}</div>
    </div>
  );
};
